interface ContentItem {
    step: number;
    content: any;
}

interface ValueItem {
    level: number;
    value: any[];
    parent?: ValueItem;
}

export class SyntaxLeveler {
    content: ContentItem[];
    constructor() {
        this.content = [];
    }

    insertLevel(step: number, content: any) {
        this.content.push({
            step,
            content,
        });
    }

    toArray() {
        let level = -1;

        const result: ValueItem = { level: 0, value: [] };
        let current: ValueItem | undefined = undefined;

        for (const item of this.content) {
            if (item.step > 0) {
                for (let i = 0; i < item.step; i++) {
                    ++level;
                    if (level === 0) {
                        current = result;
                    } else {
                        const newCurrent: ValueItem = {
                            level,
                            value: [],
                            parent: current,
                        };
                        if (current == null)
                            throw new Error("missing current in iteration");
                        current.value.push(newCurrent.value);
                        current = newCurrent;
                    }
                }
            } else if (item.step < 0) {
                for (let i = 0; i > item.step; i--) {
                    level--;

                    if (level === 0) {
                        current = result;
                    } else {
                        if (current == null)
                            throw new Error("missing current in iteration");
                        current = current.parent;
                    }
                }
            }
            if (current == null)
                throw new Error("missing current in iteration");
            current.value.push(item.content);
        }

        return result.value;
    }
}
